import { client } from '../client';
import { ClinicalDataListResponse } from './types/types';

export const listClinicalData = async (user_id: number): Promise<ClinicalDataListResponse> => {
  const { data } = await client.get<ClinicalDataListResponse>(`/clinical-data/${user_id}`);

  return data;
};
